import styled from 'astroturf/react'
import { BodyText } from '@calendly/ui/components/typography'
import _Wrapper from "reschedule_heading_summary-Wrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/reschedule_heading_summary.js?styleId=Wrapper";
import _FormerRow from "reschedule_heading_summary-FormerRow.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/reschedule_heading_summary.js?styleId=FormerRow";
import _NewRow from "reschedule_heading_summary-NewRow.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/reschedule_heading_summary.js?styleId=NewRow";
import _FormerLineStrike from "reschedule_heading_summary-FormerLineStrike.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/reschedule_heading_summary.js?styleId=FormerLineStrike";

const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'

const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

const FormerRow = /*#__PURE__*/styled('div', null, {
  displayName: "FormerRow",
  styles: _FormerRow
})

const NewRow = /*#__PURE__*/styled('div', null, {
  displayName: "NewRow",
  styles: _NewRow
})

const FormerLineStrike = /*#__PURE__*/styled('span', null, {
  displayName: "FormerLineStrike",
  styles: _FormerLineStrike
})

export const EnterDetailsRescheduleSummary = ({
  formerLineText,
  newLineText,
  formerTimeLabel,
  newTimeLabel,
  variant = 'main',
  showNewTime = true,
}) => (
  <Wrapper data-component="enter-details-reschedule-summary" data-variant={variant}>
    <FormerRow>
      <BodyText weight="bold" size="medium">{formerTimeLabel}</BodyText>
      <BodyText size="medium" color={textColorLevel2}>
        <FormerLineStrike data-strike-through={showNewTime ? 'true' : undefined}>
          {formerLineText}
        </FormerLineStrike>
      </BodyText>
    </FormerRow>
    {showNewTime && (
      <NewRow>
        <BodyText weight="bold" size="medium">{newTimeLabel}</BodyText>
        <BodyText size="medium">{newLineText}</BodyText>
      </NewRow>
    )}
  </Wrapper>
)
